import React from "react";
import { Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

export default function NavLinkItem({ label, to, onClick }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Typography
      component={RouterLink}
      to={to}
      onClick={onClick}
      sx={{
        textDecoration: "none",
        color: "black",
        mx: 1,
        position: "relative",
        fontWeight: isActive ? 700 : 500,
        "&:hover::after": {
          content: '""',
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "100%",
          height: "2px",
          backgroundColor: "black",
        },
        "&::after": {
          content: isActive ? '""' : "none",
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "100%",
          height: "2px",
          backgroundColor: "black",
        },
      }}
    >
      {label}
    </Typography>
  );
}
